<template>
  <div>
    <div v-if="link">
      <a
        v-if="checkLink(link)"
        :href="link"
        class="button"
        target="_blank"
        :class="[disable && 'disabled', styleClass ? styleClass : 'default']"
      >
        <span class="button__text">
          {{ text }}
        </span>
      </a>
      <nuxt-link
        v-else
        :to="link"
        class="button"
        :class="[disable && 'disabled', styleClass ? styleClass : 'default']"
      >
        <span class="button__text">
          {{ text }}
        </span>
      </nuxt-link>
    </div>
    <button
      v-else
      class="button"
      :class="[disable && 'disabled', styleClass ? styleClass : 'default']"
      :disabled="disable"
      @click="handleClick"
    >
      <span class="button__text">
        {{ text }}
      </span>
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Button",
  props: {
    link: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    styleClass: {
      type: [String, Object],
      default: null,
    },
    activeType: {
      type: String,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    blank: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("clickButton");
    },
    checkLink(link) {
      const str = link.substr(0, 4);
      return str === "http";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.button {
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 1.6rem;
  font-weight: 700;
  height: 4rem;
  width: 100%;
  min-width: 20rem;
  background: none;
  text-align: center;
  // white-space: nowrap;
  padding: 0 1rem;
  transition: 0.3s ease-out;

  &.default {
    border: 1px solid $blue2;
    color: $text_gray;
    &:hover {
      background: $blue2;
      color: $white;
    }
  }

  &.blue {
    border: 1px solid $blue3;
    color: $blue3;
    &:hover {
      background: $blue3;
      color: $white;
    }
  }

  &.red {
    border: 1px solid $red;
    color: $red;
    &:hover {
      background: $red;
      color: $white;
    }
  }

  &.full-red {
    border: 1px solid $red;
    background: $red;
    color: $white;
    &:hover {
      background: $white;
      color: $red;
    }
  }

  &.dark {
    border: 1px solid #425563;
    background: #425563;
    color: $white;
    &:hover {
      background: $white;
      color: #425563;
    }
  }

  &.reverse {
    flex-direction: row-reverse;
  }

  &.with-icon {
    justify-content: space-between;
    padding: 0 2rem;
    path {
      transition: 0.3s ease-out;
    }

    &:not(.disabled):hover {
      path {
        fill: $red;
      }
    }
  }

  &.small {
    height: 2rem;
    width: 7rem;
    min-width: 7rem;
    font-size: 1rem;
    padding-top: 0.1rem;
  }

  &.upper {
    text-transform: uppercase;
  }
  &.disabled {
    cursor: not-allowed;
    border: 1px solid #425563;
    background: #425563;
    color: $white;
    opacity: 0.8;
    &:hover {
      background: #425563;
      color: $white;
    }
  }
}
</style>
